<template>
<div class="checkbox_container">
  <label :for="namer" class="customi_label">
    <input type="radio" :name="namer" class="invisible customi_input" v-model="checked">
     <div class="customi_div radio">
      <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
        <circle class="svg_bg" cx="10" cy="10" r="9"/>
        <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
      </svg>
    </div>
    <span>{{label}}</span>
  </label>
</div>
</template>
<script>
export default {
  name: 'radio',
  props: ['label', 'namer'],
  methods: {
    reset () {
      this.checked = false;
    },
    toggle: function () {
      this.checked = !this.checked;
    }
  },
  data () {
    return {
      checked: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Misc/Radio.vue